import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button } from './ui';

const IntroScreen = ({ handleStartSimulation }) => (
  <Box sx={{ 
    minHeight: '100vh', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center',
    px: { xs: 2, md: 0 }, // Adiciona padding horizontal no mobile
    py: { xs: 4, md: 0 }  // Adiciona padding vertical no mobile
  }}>
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 2, md: 4 }} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography 
            variant="h1" 
            component="h1" 
            sx={{ 
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' }, 
              mb: { xs: 2, md: 3 }, 
              fontWeight: 700
            }}
          >
            Calculadora de Custos Fee Fixo
          </Typography>
          <Typography 
            variant="h5" 
            component="h2" 
            color="secondary.main"
            sx={{ 
              mb: { xs: 1.5, md: 2 }, 
              fontWeight: 600,
              fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' }
            }}
          >
            Você sabe quanto realmente paga para investir?
          </Typography>
          <Typography sx={{ 
            mb: { xs: 2, md: 3 },
            fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' }
          }}>
            Na maioria dos modelos tradicionais, sua carteira de investimentos <strong>gera
            comissões que estão embutidas</strong> nos produtos contratados. E quanto
            maior a movimentação, maiores são os custos envolvidos.
          </Typography>
          <Typography variant="h5" 
            component="h2" 
            sx={{ 
              mb: { xs: 1.5, md: 2 }, 
              color: 'secondary.main', 
              fontWeight: 600,
              fontSize: { xs: '0.95rem', sm: '1.05rem', md: '1.5rem' }
            }}>
            O problema é que, na maioria das vezes, esses custos
            não são perceptíveis.
          </Typography>
          <Typography sx={{ 
            mb: { xs: 2, md: 3 },
            fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' }
          }}>
            Essa falta de transparência pode comprometer seus resultados
            e, pior, gerar um conflito de interesse: <strong>será que a recomendação está
            de fato alinhada com os seus objetivos ou com a comissão de quem
            vendeu o produto?</strong>
          </Typography>
          <Button
            buttonType="primary"
            endIcon={<ArrowForwardIosIcon />}
            onClick={handleStartSimulation}
            sx={{ 
              borderRadius: 30, 
              backgroundColor: 'success.main', 
              '&:hover': { backgroundColor: 'success.dark' },
              fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' },
              px: { xs: 3, md: 4 },
              py: { xs: 1.5, md: 2 }
            }}
          >
            Avançar
          </Button>
        </Grid>
        <Grid item xs={12} md={5} sx={{ display: { xs: 'none', md: 'block' } }}>
          <Box 
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              mt: { xs: 3, md: 0 } // Adiciona margem top no mobile
            }}
          >
            <img 
              src="/images/calculator-phone.png" 
              alt="Celular com calculadora mostrando 30.000 e moedas"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default IntroScreen; 